<div class="merchant-container">


<div class="page-header">

<div>
<h1>Merchant Review</h1>
<p>
Validate registered vendors before allowing them on platform.
</p>
</div>


<button class="btn-refresh"
(click)="loadMerchants()">

<span class="material-symbols-outlined">
refresh
</span>

Refresh

</button>

</div>



<div *ngIf="successMsg"
class="success">

{{successMsg}}

</div>



<div *ngIf="error"
class="error">

{{error}}

</div>



<div *ngIf="loading"
class="loading">

Loading merchants...

</div>



<div *ngIf="!loading && merchants.length"
class="table-card">


<table>

<thead>

<tr>

<th>Merchant</th>
<th>Business</th>
<th>Category</th>
<th>City</th>
<th>Status</th>
<th>Action</th>

</tr>

</thead>


<tbody>


<tr *ngFor="let m of merchants">


<td>

<div class="merchant-user">


<img *ngIf="m.profile_photo"
[src]="getImageUrl(m.profile_photo)">


<div *ngIf="!m.profile_photo"
class="avatar">

{{m.owner_name?.charAt(0)}}

</div>


<div>

<strong>
{{m.owner_name}}
</strong>

<br>

<span>
{{m.phone}}
</span>

</div>


</div>

</td>



<td>

{{m.business_name}}

</td>



<td>

{{m.category?.name || 'N/A'}}

</td>



<td>

{{m.city_name ||m.city || 'N/A'}}

</td>



<td>

<span 
class="status"
[class.pending]="m.status==='PENDING'"
[class.active]="m.status==='APPROVED'"
[class.rejected]="m.status==='REJECTED'">

{{m.status}}

</span>

</td>



<td>

<button
class="review-btn"
(click)="openReview(m)">

Review

</button>

</td>


</tr>


</tbody>


</table>


</div>



<!-- REVIEW MODAL -->


<div class="overlay"
*ngIf="reviewMerchant">


<div class="modal">


<div class="modal-header">

<h2>
Merchant Verification
</h2>


<button
(click)="closeReview()">

✕

</button>


</div>



<div class="modal-body">


<div class="details-grid">


<!-- Owner Details -->

<div class="section">

<h3>
Owner Details
</h3>


<p>
Name :
<b>
{{reviewMerchant.owner_name}}
</b>
</p>


<p>
Phone :
<b>
{{reviewMerchant.phone}}
</b>
</p>


<p>
Email :
<b>
{{reviewMerchant.email}}
</b>
</p>

</div>



<!-- Business Details -->

<div class="section">

<h3>
Business Details
</h3>


<p>
Business :
<b>
{{reviewMerchant.business_name}}
</b>
</p>


<p>
Category :
<b>
{{reviewMerchant.category?.name}}
</b>
</p>


<p>
Address :
<b>
{{reviewMerchant.address_line1}},
{{reviewMerchant.area}}
</b>
</p>


</div>



<!-- Location Details -->

<div class="section">

<h3>
Location Details
</h3>


<p>
City :
<b>
{{reviewMerchant.city_name}}
</b>
</p>


<p>
District :
<b>
{{reviewMerchant.district}}
</b>
</p>


<p>
State :
<b>
{{reviewMerchant.state}}
</b>
</p>


<p>
Pincode :
<b>
{{reviewMerchant.pincode}}
</b>
</p>


</div>



<!-- Business Information -->

<div class="section">

<h3>
Business Information
</h3>


<p>
Experience :
<b>
{{reviewMerchant.years_of_experience}} years
</b>
</p>


<p>
Description :
<b>
{{reviewMerchant.business_description}}
</b>
</p>


</div>


</div>



<!-- Documents -->

<div class="documents">

<h3>
Documents
</h3>


<div class="document-grid">


<div>

<h4>
Aadhaar Card
</h4>


<img
*ngIf="reviewMerchant.aadhaar_card"
[src]="getImageUrl(reviewMerchant.aadhaar_card)"
>

</div>



<div>

<h4>
Profile Picture
</h4>


<img
*ngIf="reviewMerchant.profile_pic"
[src]="getImageUrl(reviewMerchant.profile_pic)"
>

</div>


</div>


</div>






</div>




<div class="footer">


<button
class="reject"
(click)="updateStatus('rejected')"
[disabled]="saving">

Reject

</button>



<button
class="approve"
(click)="updateStatus('approved')"
[disabled]="saving">

Approve

</button>



</div>



</div>


</div>


</div>